import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faMicrochip, faDatabase, faMobileAlt, faGlobe, faChartLine, faRobot, faShieldAlt, faCheckCircle, faGamepad, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './SoftwareServices.css';

import projectsHeroImage from '../assets/images/projects.jpg';

const SoftwareServices = () => {
  const services = [
    {
      icon: faLaptopCode,
      title: 'Kurumsal Yazılım Çözümleri',
      description: 'İşletmenize özel ERP, CRM ve iş süreçleri yönetim sistemleri geliştiriyoruz. Mevcut sistemlerinizle entegre çalışan, ölçeklenebilir ve güvenli kurumsal yazılımlar üretiyoruz.',
      features: ['ERP & CRM Sistemleri', 'İş Süreçleri Otomasyonu', 'Kurumsal Portal Çözümleri']
    },
    {
      icon: faMobileAlt,
      title: 'Mobil Uygulama Geliştirme',
      description: 'iOS ve Android platformları için native ve cross-platform mobil uygulamalar geliştiriyoruz. Kullanıcı deneyimini ön planda tutarak yüksek performanslı uygulamalar üretiyoruz.',
      features: ['iOS & Android Uygulamalar', 'Cross-Platform (React Native)', 'Push Bildirim & Yerel Özellikler']
    },
    {
      icon: faGlobe,
      title: 'Web Uygulama Geliştirme',
      description: 'Modern web teknolojileriyle güçlü, hızlı ve responsive web uygulamalar oluşturuyoruz. SPA, PWA ve e-ticaret çözümleri ile dijital varlığınızı güçlendiriyoruz.',
      features: ['SPA & PWA Uygulamalar', 'E-Ticaret Çözümleri', 'SEO Uyumlu & Responsive']
    },
    {
      icon: faRobot,
      title: 'Yapay Zeka ve Makine Öğrenmesi',
      description: 'Verilerinizden değer yaratan yapay zeka modelleri ve makine öğrenmesi çözümleri geliştiriyoruz. Doğal dil işleme, görüntü tanıma ve tahminleme sistemleri sunuyoruz.',
      features: ['NLP & Chatbot Sistemleri', 'Görüntü İşleme', 'Tahminleme Modelleri']
    },
    {
      icon: faMicrochip,
      title: 'IoT ve Gömülü Sistemler',
      description: 'Nesnelerin interneti (IoT) çözümleriyle cihazlarınızı akıllı hale getiriyoruz. Sensör entegrasyonları, SCADA sistemleri ve endüstriyel otomasyon çözümleri sunuyoruz.',
      features: ['Sensör Entegrasyonu', 'SCADA & Otomasyon', 'Edge Computing']
    },
    {
      icon: faChartLine,
      title: 'Akıllı Raporlama ve Analitik',
      description: 'İş zekası ve veri görselleştirme çözümleriyle verilerinizi anlamlı raporlara dönüştürüyoruz. Gerçek zamanlı dashboard\'lar ve özelleştirilmiş analitik sistemler geliştiriyoruz.',
      features: ['Business Intelligence', 'Dashboard Geliştirme', 'Veri Görselleştirme']
    },
    {
      icon: faDatabase,
      title: 'Eğitim Teknolojileri Yazılımı',
      description: 'Eğitim kurumları ve yayınevleri için özel yazılım çözümleri geliştiriyoruz. LMS platformları, interaktif içerik sistemleri ve akıllı tahta uygulamaları sunuyoruz.',
      features: ['LMS Platformları', 'İnteraktif İçerik', 'Akıllı Tahta Uygulamaları']
    },
    {
      icon: faShieldAlt,
      title: 'Bulut ve DevOps Çözümleri',
      description: 'AWS, Azure ve Google Cloud altyapılarında uygulamalarınızı dağıtıyor ve yönetiyoruz. CI/CD pipeline\'ları ve otomatik ölçeklendirme çözümleri sunuyoruz.',
      features: ['Cloud Migration', 'CI/CD Pipeline', 'Monitoring & Logging']
    },
    {
      icon: faGamepad,
      title: 'Oyun Geliştirme',
      description: '2D ve 3D oyun projeleri, casual ve strateji oyunları ile eğlenceli deneyimler yaratıyoruz. PC, konsol ve mobil platformlar için oyun geliştirme hizmeti sunuyoruz.',
      features: ['2D & 3D Oyun Projeleri', 'Mobil Oyun Geliştirme', 'Oyunlaştırma & Ödül Sistemleri']
    }
  ];

  const sectorSolutions = [
    { title: 'Eğitim Yazılımları', description: 'LMS, video ders, sertifika ve sınav modülleri', features: ['Öğrenme yönetim sistemleri', 'Video streaming ve canlı ders', 'İlerleme takibi ve raporlama'] },
    { title: 'E-Ticaret Yazılımı', description: 'Online mağaza, ödeme, stok ve sipariş yönetimi', features: ['Ürün kataloğu ve sepet', 'Ödeme sistemi entegrasyonu', 'Kargo ve fatura entegrasyonları'] },
    { title: 'Finans & Fintech', description: 'Ödeme, transfer, raporlama ve uyumluluk çözümleri', features: ['Ödeme ve transfer modülleri', 'Güvenli kimlik doğrulama', 'Raporlama ve uyumluluk'] },
    { title: 'Sağlık Yazılımları', description: 'Randevu, hasta takibi ve tıbbi kayıt yönetimi', features: ['Randevu ve hasta yönetimi', 'KVKK uyumlu veri işleme', 'Dijital kayıt ve arşiv'] },
    { title: 'CRM Çözümleri', description: 'Müşteri veritabanı, satış hunisi ve iletişim takibi', features: ['Müşteri ve lead yönetimi', 'Satış pipeline', 'E-posta ve iletişim kaydı'] },
    { title: 'Lojistik Yazılımları', description: 'Filo takibi, rota optimizasyonu ve depo yönetimi', features: ['Filo ve sürücü takibi', 'Rota ve teslimat planlama', 'Depo ve stok yönetimi'] },
    { title: 'İnsan Kaynakları', description: 'İşe alım, performans, izin ve bordro süreçleri', features: ['İK süreçleri ve formlar', 'Performans ve hedef takibi', 'Kurumsal portal'] },
    { title: 'İçerik Yönetimi (CMS)', description: 'Çok dilli, çok kanallı içerik yönetim sistemleri', features: ['Dinamik sayfa yönetimi', 'Çoklu dil ve medya', 'SEO ve yayın planlama'] },
    { title: 'Proje Yönetimi', description: 'Görev, sprint, zaman takibi ve kaynak planlama', features: ['Görev ve sprint yönetimi', 'Gantt ve kanban görünümleri', 'Ekip ve rol yönetimi'] },
    { title: 'Sosyal Medya & Topluluk', description: 'Sosyal ağ, forum, içerik paylaşımı ve bildirimler', features: ['Profil ve etkileşim', 'İçerik paylaşımı ve yorum', 'Moderasyon ve güvenlik'] },
    { title: 'Restoran & Yemek', description: 'Online sipariş, masa yönetimi ve QR menü', features: ['Online sipariş ve rezervasyon', 'QR menü ve ödeme', 'Mutfak ve stok entegrasyonu'] },
    { title: 'Dashboard & Analitik', description: 'KPI takibi, raporlama ve veri görselleştirme', features: ['Özelleştirilebilir KPI panelleri', 'Gerçek zamanlı raporlama', 'Dış sistem entegrasyonu'] },
  ];

  const faqItems = [
    { q: 'Yazılım projesi için teklif nasıl alınır?', a: 'Fiyat hesaplayıcımızla proje türü ve özellikleri seçerek anında tahmini bütçe alabilirsiniz. Detaylı teklif için iletişim formundan bize ulaşın.' },
    { q: 'Teklif ücretsiz mi?', a: 'Evet. Tüm fiyat teklifleri ve danışmanlık hizmeti ücretsizdir; hiçbir ödeme taahhüdü yoktur.' },
    { q: 'Hangi tür yazılım projeleri için teklif veriyorsunuz?', a: 'Web uygulaması, mobil uygulama (iOS/Android), oyun geliştirme (PC, mobil, 2D/3D) ve özel yazılım projeleri için teklif sunuyoruz.' },
  ];

  return (
    <div className="software-services">
      <Helmet>
        <title>ProgenX Yazılım Hizmetleri | Kurumsal Yazılım, AI, IoT Çözümleri 2026</title>
        <meta name="description" content="ProgenX yazılım hizmetleri: Kurumsal yazılım çözümleri, mobil uygulama geliştirme, web uygulama, yapay zeka, IoT, akıllı raporlama ve eğitim teknolojileri yazılımı. Ankara merkezli yazılım şirketi." />
        <meta name="keywords" content="yazılım hizmetleri, kurumsal yazılım, mobil uygulama, web geliştirme, yapay zeka, IoT, akıllı raporlama, eğitim yazılımı, ankara yazılım şirketi, oyun geliştirme, e-ticaret yazılımı" />
        <meta property="og:title" content="ProgenX Yazılım Hizmetleri | Kurumsal Yazılım ve AI Çözümleri" />
        <meta property="og:description" content="Kurumsal yazılım, yapay zeka, IoT ve akıllı raporlama alanlarında profesyonel yazılım hizmetleri." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/yazilim-hizmetleri" />
        <link rel="canonical" href="https://progenx.com.tr/yazilim-hizmetleri" />
        <link rel="alternate" hrefLang="tr" href="https://progenx.com.tr/yazilim-hizmetleri" />
        <link rel="alternate" hrefLang="en" href="https://progenx.com.tr/en/software-services" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqItems.map(item => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": { "@type": "Answer", "text": item.a }
          }))
        })}</script>
      </Helmet>

      <Hero 
        title="YAZILIM HİZMETLERİ" 
        backgroundImage={projectsHeroImage}
      />

      <section className="services-content">
        <div className="container">
          <h2 className="section-title">Yazılım Çözümlerimiz</h2>
          <p className="services-intro">
            ProgenX olarak, eğitimden endüstriye geniş bir yelpazede yazılım hizmetleri sunuyoruz. 
            Her projeye özel, ölçeklenebilir ve sürdürülebilir çözümler üretiyor; müşterilerimizin 
            dijital dönüşüm süreçlerinde güvenilir bir teknoloji ortağı oluyoruz.
          </p>

          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">
                  <FontAwesomeIcon icon={service.icon} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, i) => (
                    <li key={i}>
                      <FontAwesomeIcon icon={faCheckCircle} className="feature-check-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sector-solutions">
        <div className="container">
          <h2 className="section-title">Sektöre ve Alana Özel Yazılımlar</h2>
          <p className="services-intro">
            Eğitim, IoT, e-ticaret, finans, sağlık, CRM, lojistik ve daha fazlası. Sektörünüze özel
            yazılım çözümleri ile iş süreçlerinizi dijitalleştiriyoruz.
          </p>
          <div className="sector-grid">
            {sectorSolutions.map((solution, index) => (
              <div key={index} className="sector-card">
                <h3 className="sector-card-title">{solution.title}</h3>
                <p className="sector-card-desc">{solution.description}</p>
                <ul className="sector-card-features">
                  {solution.features.map((feature, i) => (
                    <li key={i}>
                      <FontAwesomeIcon icon={faCheckCircle} className="feature-check-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/yazilim-hesaplayici" className="sector-card-link">
                  Teklif Al <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-faq">
        <div className="container">
          <h2 className="section-title">Sık Sorulan Sorular</h2>
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <div key={index} className="faq-item">
                <h3 className="faq-question">{item.q}</h3>
                <p className="faq-answer">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-cta-section">
        <div className="container">
          <h3>Projeniz İçin Maliyet Tahmini Alın</h3>
          <p>Yazılım projelerinizin tahmini maliyetini hesaplamak için ücretsiz aracımızı kullanın.</p>
          <div className="services-cta-buttons">
            <Link to="/yazilim-hesaplayici" className="btn btn-primary">
              MALİYET HESAPLA <FontAwesomeIcon icon={faArrowRight} />
            </Link>
            <Link to="/iletisim" className="btn">İLETİŞİME GEÇ</Link>
          </div>
        </div>
      </section>

      <CallToAction 
        title="Projenizi Birlikte Hayata Geçirelim"
        subtitle="Yazılım ihtiyaçlarınız için bize ulaşın, birlikte en doğru çözümü üretelim."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default SoftwareServices;
